import { useQuery } from 'react-query';
import { getAuditLogTags } from '~/api/auditLog';

export const useGetTags = () => {
  return useQuery('tags', getAuditLogTags, { staleTime: Infinity });
};
